module.exports = __webpack_public_path__ + "media/icons/extras--one-off-40ffe668.svg";